"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var ListItem_1 = __importDefault(require("semantic-ui-react/dist/commonjs/elements/List/ListItem"));
var ListHeader_1 = __importDefault(require("semantic-ui-react/dist/commonjs/elements/List/ListHeader"));
var ListIcon_1 = __importDefault(require("semantic-ui-react/dist/commonjs/elements/List/ListIcon"));
var ListContent_1 = __importDefault(require("semantic-ui-react/dist/commonjs/elements/List/ListContent"));
var genIcon_1 = __importDefault(require("../../../utils/genIcon"));
/**
 * Each item in a List is contained in a child ListContent component.
 */
var ListContent = /** @class */ (function (_super) {
    __extends(ListContent, _super);
    function ListContent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.genClasses = function () {
            var _a = _this.props, onClick = _a.onClick, className = _a.className;
            return onClick ? 'clickable ' + className : className;
        };
        return _this;
    }
    ListContent.prototype.render = function () {
        var _a = this.props, iconName = _a.iconName, header = _a.header, children = _a.children, iconRoot = _a.iconRoot, className = _a.className, cleanedProps = __rest(_a, ["iconName", "header", "children", "iconRoot", "className"]);
        return (React.createElement(ListItem_1.default, __assign({}, cleanedProps, { className: this.genClasses() }),
            iconName && (React.createElement(ListIcon_1.default, null, genIcon_1.default(iconName, { root: iconRoot, exactSize: 17 }))),
            React.createElement(ListContent_1.default, null,
                React.createElement(ListHeader_1.default, null, header),
                children)));
    };
    ListContent.defaultProps = {
        iconRoot: 'common'
    };
    return ListContent;
}(React.Component));
exports.default = ListContent;
